// extracted by mini-css-extract-plugin
module.exports = {"container":"Serie_container__KaI_D","serie":"Serie_serie__cSbI_","theme":"Serie_theme__3pGWr","points":"Serie_points__35Pqm","question":"Serie_question__2qTfl"};